import { apiGet } from '@gat-ship/http-client'
import type { SearchedVesselRef } from '@gat-ship/types'

interface SearchVesselsResponse {
  vessels: SearchedVesselRef[]
  limit: number
}

/**
 * Searches global master vessels by free text (name, IMO, …).
 *
 * @param query Search text. An empty/blank query yields no results.
 * @param options.limit Max results — defaults to 10, clamped to 50 by the API.
 * @param options.signal Abort signal for cancelling an in-flight search.
 */
export async function searchVesselsRequest(
  query: string,
  options?: { limit?: number; signal?: AbortSignal }
): Promise<SearchedVesselRef[]> {
  const response = await apiGet<SearchVesselsResponse>(
    'ref-data/vessels/search',
    {
      params: { query, limit: options?.limit },
      signal: options?.signal
    }
  )
  return response.vessels
}
